module.exports = __webpack_public_path__ + "img/qq.485b4891.svg";